import React from 'react';
import { motion } from 'framer-motion';
export function ShowcaseSlide() {
  return <div className="h-full w-full flex flex-col items-center justify-center px-8 bg-slate-950" data-id="element-128">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center mb-12" data-id="element-129">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-130">
          Built for Scale
        </h2>
        <p className="text-lg text-slate-400" data-id="element-131">
          A unified experience for drivers and operators
        </p>
      </motion.div>

      <div className="flex flex-col md:flex-row gap-12 items-center max-w-7xl w-full" data-id="element-132">
        {/* Mobile App Showcase */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex-1 flex flex-col items-center" data-id="element-133">
          <div className="relative rounded-[2.5rem] overflow-hidden border-8 border-slate-800 shadow-2xl bg-slate-900 max-w-[300px]" data-id="element-134">
            <img src="https://cdn.magicpatterns.com/uploads/6rYyCYqHGyAUiQz8hAzmJQ/app.png" alt="Mobile App Interface" className="w-full h-auto object-cover" data-id="element-135" />
          </div>
          <p className="mt-6 text-slate-300 font-medium text-center" data-id="element-136">
            White-label driver app with real-time insights
          </p>
        </motion.div>

        {/* Portal Showcase */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex-[1.5] flex flex-col items-center" data-id="element-137">
          <div className="relative rounded-xl overflow-hidden border-4 border-slate-800 shadow-2xl bg-slate-900 w-full" data-id="element-138">
            <div className="h-6 bg-slate-800 flex items-center px-4 gap-2" data-id="element-139">
              <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-140" />
              <div className="w-2 h-2 rounded-full bg-yellow-500" data-id="element-141" />
              <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-142" />
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/bCG7336NMj7UfBodDjkiQa/portal.png" alt="Management Portal Interface" className="w-full h-auto object-cover" data-id="element-143" />
          </div>
          <p className="mt-6 text-slate-300 font-medium text-center" data-id="element-144">
            Centralized management for all installations
          </p>
        </motion.div>
      </div>
    </div>;
}